// extracted by mini-css-extract-plugin
module.exports = {"hero":"Layout-module__hero--17QFW"};